import { render } from "./IconNumber.vue?vue&type=template&id=345316d5"
import script from "./IconNumber.vue?vue&type=script&lang=ts"
export * from "./IconNumber.vue?vue&type=script&lang=ts"
script.render = render

export default script